const mapTextsFr = {
  "kartenLegende": "",
  "land": "Pays",
  "risikokategorie": "Classification des risques",
  "legendenKuerzel": "CRP ",
  "engagement": "L'engagement en CHF mio.",
  "backbutton": "retour",
  "zero": "0,0",
  "newCommitment": "Le nouvel engagement en CHF mio.",

  "country": {
    "et": {
      "title": "Ethiopie",
      "region": "Afrique subsaharienne"
    },
    "gq": {
      "title": "Guinée équatoriale",
      "region": "Afrique subsaharienne"
    },
    "af": {
      "title": "Afghanistan",
      "region": "Asie du Sud"
    },
    "eg": {
      "title": "Egypte",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "al": {
      "title": "Albanie",
      "region": "Europe de l’est & Asie centrale"
    },
    "dz": {
      "title": "Algérie",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "ao": {
      "title": "Angola",
      "region": "Afrique subsaharienne"
    },
    "ag": {
      "title": "Antigua-et-Barbuda",
      "region": "Amérique latine & Caraïbes"
    },
    "an": {
      "title": "Antilles néerlandaises^",
      "region": "Amérique latine & Caraïbes"
    },
    "ar": {
      "title": "Argentine",
      "region": "Amérique latine & Caraïbes"
    },
    "am": {
      "title": "Arménie",
      "region": "Europe de l’est & Asie centrale"
    },
    "aw": {
      "title": "Aruba",
      "region": "Amérique latine & Caraïbes"
    },
    "az": {
      "title": "Azerbaïdjan",
      "region": "Europe de l’est & Asie centrale"
    },
    "au": {
      "title": "Australie",
      "region": "Asie de l’Est & Pacifique"
    },
    "bs": {
      "title": "Bahamas",
      "region": "Amérique latine & Caraïbes"
    },
    "bh": {
      "title": "Bahreïn",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "bd": {
      "title": "Bangladesh",
      "region": "Asie du Sud"
    },
    "bb": {
      "title": "Barbade",
      "region": "Amérique latine & Caraïbes"
    },
    "by": {
      "title": "Bélarus",
      "region": "Europe de l’est & Asie centrale"
    },
    "be": {
      "title": "Belgique",
      "region": "Europe de l’Ouest"
    },
    "bz": {
      "title": "Belize",
      "region": "Amérique latine & Caraïbes"
    },
    "bj": {
      "title": "Bénin",
      "region": "Afrique subsaharienne"
    },
    "bm": {
      "title": "Bermudes",
      "region": "Amérique latine & Caraïbes"
    },
    "bt": {
      "title": "Bhoutan",
      "region": "Europe de l’est & Asie centrale"
    },
    "bo": {
      "title": "Bolivie",
      "region": "Amérique latine & Caraïbes"
    },
    "ba": {
      "title": "Bosnie et Herzégovine",
      "region": "Europe de l’est & Asie centrale"
    },
    "bw": {
      "title": "Botswana",
      "region": "Afrique subsaharienne"
    },
    "br": {
      "title": "Brésil",
      "region": "Amérique latine & Caraïbes"
    },
    "bn": {
      "title": "Brunéi Darussalam",
      "region": "Asie du Sud"
    },
    "bg": {
      "title": "Bulgarie",
      "region": "Europe de l’est & Asie centrale"
    },
    "bf": {
      "title": "Burkina Faso",
      "region": "Afrique subsaharienne"
    },
    "bi": {
      "title": "Burundi",
      "region": "Afrique subsaharienne"
    },
    "cl": {
      "title": "Chili",
      "region": "Amérique latine & Caraïbes"
    },
    "cn": {
      "title": "Chine",
      "region": "Asie de l’Est & Pacifique"
    },
    "cr": {
      "title": "Costa Rica",
      "region": "Amérique latine & Caraïbes"
    },
    "ci": {
      "title": "Côte d'Ivoire",
      "region": "Afrique subsaharienne"
    },
    "cw": {
      "title": "Curaçao (Pays-Bas)",
      "region": "Amérique latine & Caraïbes"
    },
    "dk": {
      "title": "Danemark",
      "region": "Europe de l’Ouest"
    },
    "de": {
      "title": "Allemagne",
      "region": "Europe de l’Ouest"
    },
    "do": {
      "title": "République dominicaine",
      "region": "Amérique latine & Caraïbes"
    },
    "dj": {
      "title": "Djibouti",
      "region": "Afrique subsaharienne"
    },
    "ec": {
      "title": "Equateur",
      "region": "Amérique latine & Caraïbes"
    },
    "sv": {
      "title": "El Salvador",
      "region": "Amérique latine & Caraïbes"
    },
    "er": {
      "title": "Erythrée",
      "region": "Afrique subsaharienne"
    },
    "ee": {
      "title": "Estonie",
      "region": "Europe de l’est & Asie centrale"
    },
    "sz": {
      "title": "Eswatini",
      "region": "Afrique subsaharienne"
    },
    "fj": {
      "title": "Iles Fidji",
      "region": "Asie de l’Est & Pacifique"
    },
    "fi": {
      "title": "Finlande",
      "region": "Europe de l’Ouest"
    },
    "fr": {
      "title": "France",
      "region": "Europe de l’Ouest"
    },
    "pf": {
      "title": "Polynésie française",
      "region": "Asie de l’Est & Pacifique"
    },
    "ga": {
      "title": "Gabon",
      "region": "Afrique subsaharienne"
    },
    "gm": {
      "title": "Gambie",
      "region": "Afrique subsaharienne"
    },
    "ge": {
      "title": "Géorgie",
      "region": "Europe de l’est & Asie centrale"
    },
    "gh": {
      "title": "Ghana",
      "region": "Afrique subsaharienne"
    },
    "gl": {
      "title": "Groenland",
      "region": "Amérique du Nord"
    },
    "gd": {
      "title": "Grenade",
      "region": "Amérique latine & Caraïbes"
    },
    "gr": {
      "title": "Grèce",
      "region": "Europe de l’Ouest"
    },
    "gb": {
      "title": "Grande-Bretagne",
      "region": "Europe de l’Ouest"
    },
    "gp": {
      "title": "Guadeloupe",
      "region": "Amérique latine & Caraïbes"
    },
    "gt": {
      "title": "Guatemala",
      "region": "Amérique latine & Caraïbes"
    },
    "gn": {
      "title": "Guinée",
      "region": "Afrique subsaharienne"
    },
    "gw": {
      "title": "Guinée-Bissau",
      "region": "Afrique subsaharienne"
    },
    "gy": {
      "title": "Guyana",
      "region": "Amérique latine & Caraïbes"
    },
    "ht": {
      "title": "Haïti",
      "region": "Amérique latine & Caraïbes"
    },
    "hn": {
      "title": "Honduras",
      "region": "Amérique latine & Caraïbes"
    },
    "hk": {
      "title": "Hong Kong",
      "region": "Asie de l’Est & Pacifique"
    },
    "in": {
      "title": "Inde",
      "region": "Asie du Sud"
    },
    "id": {
      "title": "Indonésie",
      "region": "Asie de l’Est & Pacifique"
    },
    "iq": {
      "title": "Irak",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "ir": {
      "title": "Iran",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "ie": {
      "title": "Irlande",
      "region": "Europe de l’Ouest"
    },
    "is": {
      "title": "Islande",
      "region": "Europe de l’Ouest"
    },
    "il": {
      "title": "Israël",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "it": {
      "title": "Italie",
      "region": "Europe de l’Ouest"
    },
    "jm": {
      "title": "Jamaïque",
      "region": "Amérique latine & Caraïbes"
    },
    "jp": {
      "title": "Japon",
      "region": "Asie de l’Est & Pacifique"
    },
    "ye": {
      "title": "Yémen",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "jo": {
      "title": "Jordanie",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "kh": {
      "title": "Cambodge",
      "region": "Asie de l’Est & Pacifique"
    },
    "cm": {
      "title": "Cameroun",
      "region": "Afrique subsaharienne"
    },
    "ca": {
      "title": "Canada",
      "region": "Amérique du Nord"
    },
    "cv": {
      "title": "Cap-Vert",
      "region": "Afrique subsaharienne"
    },
    "kz": {
      "title": "Kazakhstan",
      "region": "Europe de l’est & Asie centrale"
    },
    "qa": {
      "title": "Qatar",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "ke": {
      "title": "Kenya",
      "region": "Afrique subsaharienne"
    },
    "kg": {
      "title": "Kirghizistan",
      "region": "Europe de l’est & Asie centrale"
    },
    "ki": {
      "title": "Kiribati",
      "region": "Asie de l’Est & Pacifique"
    },
    "co": {
      "title": "Colombie",
      "region": "Amérique latine & Caraïbes"
    },
    "km": {
      "title": "Comoros",
      "region": "Afrique subsaharienne"
    },
    "cg": {
      "title": "Congo (Brazzaville)",
      "region": "Afrique subsaharienne"
    },
    "cd": {
      "title": "Congo (Kinshasa)",
      "region": "Afrique subsaharienne"
    },
    "kp": {
      "title": "Corée du Nord",
      "region": "Asie du Sud"
    },
    "kr": {
      "title": "Corée du Sud",
      "region": "Asie du Sud"
    },
    "xk": {
      "title": "Kosovo",
      "region": "Europe de l’est & Asie centrale"
    },
    "hr": {
      "title": "Croatie",
      "region": "Europe de l’est & Asie centrale"
    },
    "cu": {
      "title": "Cuba",
      "region": "Amérique latine & Caraïbes"
    },
    "kw": {
      "title": "Koweït",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "la": {
      "title": "Laos",
      "region": "Asie du Sud"
    },
    "ls": {
      "title": "Lesotho",
      "region": "Afrique subsaharienne"
    },
    "lv": {
      "title": "Lettonie",
      "region": "Europe de l’Ouest"
    },
    "lb": {
      "title": "Liban",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "lr": {
      "title": "Libéria",
      "region": "Afrique subsaharienne"
    },
    "ly": {
      "title": "Libye",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "li": {
      "title": "Liechtenstein",
      "region": "Europe de l’Ouest"
    },
    "lt": {
      "title": "Lituanie",
      "region": "Europe de l’est & Asie centrale"
    },
    "lu": {
      "title": "Luxembourg",
      "region": "Europe de l’Ouest"
    },
    "mo": {
      "title": "Macao",
      "region": "Asie de l’Est & Pacifique"
    },
    "mg": {
      "title": "Madagascar",
      "region": "Afrique subsaharienne"
    },
    "mw": {
      "title": "Malawi",
      "region": "Afrique subsaharienne"
    },
    "my": {
      "title": "Malaisie",
      "region": "Asie de l’Est & Pacifique"
    },
    "mv": {
      "title": "Maldives",
      "region": "Asie du Sud"
    },
    "ml": {
      "title": "Mali",
      "region": "Afrique subsaharienne"
    },
    "mt": {
      "title": "Malte",
      "region": "Europe de l’Ouest"
    },
    "ma": {
      "title": "Maroc",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "mq": {
      "title": "Martinique",
      "region": "Amérique latine & Caraïbes"
    },
    "mr": {
      "title": "Mauritanie",
      "region": "Afrique subsaharienne"
    },
    "mu": {
      "title": "Maurice",
      "region": "Afrique subsaharienne"
    },
    "mk": {
      "title": "Macédoine",
      "region": "Europe de l’est & Asie centrale"
    },
    "mx": {
      "title": "Mexique",
      "region": "Amérique latine & Caraïbes"
    },
    "md": {
      "title": "Moldova",
      "region": "Europe de l’est & Asie centrale"
    },
    "mn": {
      "title": "Mongolie",
      "region": "Europe de l’est & Asie centrale"
    },
    "me": {
      "title": "Monténégro",
      "region": "Europe de l’est & Asie centrale"
    },
    "mz": {
      "title": "Mozambique",
      "region": "Afrique subsaharienne"
    },
    "mm": {
      "title": "Myanmar",
      "region": "Asie du Sud"
    },
    "na": {
      "title": "Namibie",
      "region": "Afrique subsaharienne"
    },
    "np": {
      "title": "Népal",
      "region": "Asie du Sud"
    },
    "nz": {
      "title": "Nouvelle-Zélande",
      "region": "Asie de l’Est & Pacifique"
    },
    "ni": {
      "title": "Nicaragua",
      "region": "Amérique latine & Caraïbes"
    },
    "nl": {
      "title": "Pays-Bas",
      "region": "Europe de l’Ouest"
    },
    "ne": {
      "title": "Niger",
      "region": "Afrique subsaharienne"
    },
    "ng": {
      "title": "Nigéria",
      "region": "Afrique subsaharienne"
    },
    "no": {
      "title": "Norvège",
      "region": "Europe de l’Ouest"
    },
    "om": {
      "title": "Oman",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "at": {
      "title": "Autriche",
      "region": "Europe de l’Ouest"
    },
    "pk": {
      "title": "Pakistan",
      "region": "Asie du Sud"
    },
    "pa": {
      "title": "Panama",
      "region": "Amérique latine & Caraïbes"
    },
    "pg": {
      "title": "Papouasie-Nouvelle-Guinée",
      "region": "Asie de l’Est & Pacifique"
    },
    "py": {
      "title": "Paraguay",
      "region": "Amérique latine & Caraïbes"
    },
    "pe": {
      "title": "Pérou",
      "region": "Amérique latine & Caraïbes"
    },
    "ph": {
      "title": "Philippines",
      "region": "Asie de l’Est & Pacifique"
    },
    "pl": {
      "title": "Pologne",
      "region": "Europe de l’est & Asie centrale"
    },
    "pt": {
      "title": "Portugal",
      "region": "Europe de l’Ouest"
    },
    "pr": {
      "title": "Port Rico^",
      "region": "Amérique latine & Caraïbes"
    },
    "re": {
      "title": "La Réunion",
      "region": "Amérique latine & Caraïbes"
    },
    "rw": {
      "title": "Rwanda",
      "region": "Afrique subsaharienne"
    },
    "ro": {
      "title": "Roumanie",
      "region": "Europe de l’est & Asie centrale"
    },
    "ru": {
      "title": "Russie",
      "region": "Europe de l’est & Asie centrale"
    },
    "": {
      "title": "Iles Salomon",
      "region": "Asie de l’Est & Pacifique"
    },
    "zm": {
      "title": "Zambie",
      "region": "Afrique subsaharienne"
    },
    "as": {
      "title": "Samoa",
      "region": "Asie de l’Est & Pacifique"
    },
    "st": {
      "title": "São Tomé-et-Principe",
      "region": "Afrique subsaharienne"
    },
    "sa": {
      "title": "Arabie saoudite",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "se": {
      "title": "Suède",
      "region": "Europe de l’Ouest"
    },
    "ch": {
      "title": "Suisse",
      "region": "Europe de l’Ouest"
    },
    "sn": {
      "title": "Sénégal",
      "region": "Afrique subsaharienne"
    },
    "rs": {
      "title": "Serbie",
      "region": "Europe de l’est & Asie centrale"
    },
    "sc": {
      "title": "Seychelles",
      "region": "Afrique subsaharienne"
    },
    "sl": {
      "title": "Sierra Leone",
      "region": "Afrique subsaharienne"
    },
    "zw": {
      "title": "Zimbabwe",
      "region": "Afrique subsaharienne"
    },
    "sg": {
      "title": "Singapour",
      "region": "Asie de l’Est & Pacifique"
    },
    "sk": {
      "title": "Slovaquie",
      "region": "Europe de l’est & Asie centrale"
    },
    "si": {
      "title": "Slovénie",
      "region": "Europe de l’Ouest"
    },
    "so": {
      "title": "Somalie",
      "region": "Afrique subsaharienne"
    },
    "es": {
      "title": "Espagne",
      "region": "Europe de l’Ouest"
    },
    "lk": {
      "title": "Sri Lanka",
      "region": "Asie du Sud"
    },
    "kn": {
      "title": "Saint-Kitts-et-Nevis",
      "region": "Amérique latine & Caraïbes"
    },
    "vc": {
      "title": "Saint-Vincent-et-les-Grenadines",
      "region": "Amérique latine & Caraïbes"
    },
    "za": {
      "title": "Afrique du Sud",
      "region": "Afrique subsaharienne"
    },
    "sd": {
      "title": "Soudan",
      "region": "Afrique subsaharienne"
    },
    "ss": {
      "title": "Soudan du Sud",
      "region": "Afrique subsaharienne"
    },
    "sr": {
      "title": "Suriname",
      "region": "Amérique latine & Caraïbes"
    },
    "sy": {
      "title": "Syrie",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "tj": {
      "title": "Tadjikistan",
      "region": "Europe de l’est & Asie centrale"
    },
    "tw": {
      "title": "Taïwan (Taipei chinois)",
      "region": "Asie de l’Est & Pacifique"
    },
    "tz": {
      "title": "Tanzanie",
      "region": "Afrique subsaharienne"
    },
    "th": {
      "title": "Thaïlande",
      "region": "Asie de l’Est & Pacifique"
    },
    "tp": {
      "title": "Timor-Leste",
      "region": "Asie du Sud"
    },
    "tg": {
      "title": "Togo",
      "region": "Afrique subsaharienne"
    },
    "tk": {
      "title": "Trinité-et-Tobago",
      "region": "Amérique latine & Caraïbes"
    },
    "td": {
      "title": "Tchad",
      "region": "Afrique subsaharienne"
    },
    "cz": {
      "title": "République tchèque",
      "region": "Europe de l’est & Asie centrale"
    },
    "tn": {
      "title": "Tunisie",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "tr": {
      "title": "Turquie",
      "region": "Europe de l’est & Asie centrale"
    },
    "tm": {
      "title": "Turkménistan",
      "region": "Europe de l’est & Asie centrale"
    },
    "tv": {
      "title": "Tuvalu",
      "region": "Asie de l’Est & Pacifique"
    },
    "ug": {
      "title": "Ouganda",
      "region": "Afrique subsaharienne"
    },
    "ua": {
      "title": "Ukraine",
      "region": "Europe de l’est & Asie centrale"
    },
    "hu": {
      "title": "Hongrie",
      "region": "Europe de l’est & Asie centrale"
    },
    "uy": {
      "title": "Uruguay",
      "region": "Amérique latine & Caraïbes"
    },
    "uz": {
      "title": "Ouzbékistan",
      "region": "Europe de l’est & Asie centrale"
    },
    "vu": {
      "title": "Vanuatu",
      "region": "Asie de l’Est & Pacifique"
    },
    "ve": {
      "title": "Venezuela",
      "region": "Amérique latine & Caraïbes"
    },
    "ae": {
      "title": "Emirats arabes unis",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "us": {
      "title": "Etats-Unis",
      "region": "Amérique du Nord"
    },
    "vn": {
      "title": "Vietnam",
      "region": "Asie de l’Est & Pacifique"
    },
    "we": {
      "title": "Cisjordanie et bande de Gaza",
      "region": "Proche-Orient & Afrique du Nord"
    },
    "cf": {
      "title": "République centrafricaine",
      "region": "Afrique subsaharienne"
    },
    "cy": {
      "title": "Chypre",
      "region": "Europe de l’Ouest"
    }
  }
};

export default mapTextsFr;
